export default __webpack_public_path__ + "static/media/lightbulb.b65605a6.svg";